// @flow
import SearchAPI from '../library/SearchAPI';

export const ORGANIZATIONS_REQUEST = 'organizations/REQUEST';
export const ORGANIZATIONS_SUCCESS = 'organizations/SUCCESS';
export const ORGANIZATIONS_ERROR = 'organizations/ERROR';

const organizationsRequest = () => ({
  type: ORGANIZATIONS_REQUEST
});

const organizationsSuccess = data => ({
  type: ORGANIZATIONS_SUCCESS,
  payload: data
});

const organizationsError = error => ({
  type: ORGANIZATIONS_ERROR,
  payload: error
});

export const getOrganizations = () => {
  return async dispatch => {
    dispatch(organizationsRequest());

    try {
      // Essayer d'utiliser SearchAPI.getPermissions pour récupérer l'organisation de l'utilisateur
      const response = await SearchAPI.getPermissions([
        'https://books-openedition-org.ezscd.univ-lyon3.fr/test'
      ], 'OB');

      if (
        response &&
        response.data &&
        response.data.organization &&
        response.data.organization.shortname
      ) {
        dispatch(organizationsSuccess([response.data.organization]));
      } else {
        // Si pas d'organisation spécifique, renvoyer null
        dispatch(organizationsSuccess(null));
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des organisations:', error);
      dispatch(organizationsError(error.message));
      dispatch(organizationsSuccess(null));
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/organizations.js